import { render, staticRenderFns } from "./SendMessageGroupMemberEdit.vue?vue&type=template&id=5d0eda32&scoped=true&lang=pug"
import script from "./SendMessageGroupMemberEdit.vue?vue&type=script&lang=ts"
export * from "./SendMessageGroupMemberEdit.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageGroupMemberEdit.vue?vue&type=style&index=0&id=5d0eda32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0eda32",
  null
  
)

export default component.exports